import 'nodelist-foreach-polyfill';
import { addEventListener } from 'event-listener-with-options';
import '../modal';
import './_hamburger.scss';
import './_search.scss';
import './header.scss';

document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('[data-scroll-class]');
  if (targets.length !== 0) {
    addEventListener(window, 'scroll', () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const shouldHaveClass = scrollTop > 10;
      targets.forEach((el) => {
        const toggleClass = el.dataset.scrollClass;
        const hasClass = el.classList.contains(toggleClass);
        if (hasClass !== shouldHaveClass) {
          el.classList.toggle(toggleClass);
        }
      });
    }, { passive: true });
  }

  const searchToggle = document.querySelector('[data-search-toggle]');
  const modal = document.querySelector('.modal');
  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      addEventListener(modal, 'transitionend', () => {
        const searchInput = modal.querySelector('[data-search-input]');
        if (searchInput) {
          searchInput.focus();
        }
      }, { once: true });
    });
  }

  const hamburger = document.querySelector('[data-hamburger]');
  if (hamburger) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('hamburger_opened');
    });
  }
});
